import React, { useEffect, useState } from 'react';
import './NetflixTitle.css';
import { useNavigate } from 'react-router-dom';
import logoImage from './images/logo_vinayak.png'; // Using Vinayak's preferred logo

const NetflixTitle = () => {
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();

  const handlePlaySound = () => {
    // Using a direct CDN link for Netflix sound
    const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
    audio.play().catch(error => console.error("Audio play error:", error));
    setIsClicked(true); // Starts animation after clicking
  };

  useEffect(() => {
    if (isClicked) {
      const timer = setTimeout(() => {
        navigate('/browse');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isClicked, navigate]);

  return (
    <div className="netflix-container" onClick={handlePlaySound}>
      <img
        src={logoImage}
        alt="Custom Logo"
        className={`netflix-logo ${isClicked ? 'animate' : 'visible'}`}
      />
      {/* Fallback text in case image doesn't load */}
      <div className="fallback-text">
        <p>Click anywhere to start</p>
        <p className="small-text">(Vinayak Singh's Portfolio)</p>
        {/* Direct navigation link */}
        <button className="direct-link" onClick={(e) => {
          e.stopPropagation();
          navigate('/browse');
        }}>
          Go to Browse Page
        </button>
      </div>
    </div>
  );
};

export default NetflixTitle;